import type { GridStateColDef } from "@mui/x-data-grid-premium";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import { when } from "util/support";
import Tabs from "ui/atoms/Tabs";
import { Collection } from "ui/support/Resource";
import { withTransaction } from "./TransactionProvider";
import useTransactionDetails from "./useTransactionDetails";
import CurrentTransactionState from "./CurrentTransactionState";
import TransactionActions from "./TransactionActions";
import ChildTransactions from "./ChildTransactions";

const TransactionDetails = () => {
    const {
        children,
        fromColumns,
        renderDetailRow
    } = useTransactionDetails();

    return (
        <Paper
            sx={{
                flex: 1,
                ml: 2,
                width: '100%',
                p: 1
            }}
        >
            <Tabs
                model={[
                    {
                        label: 'Transaction Details',
                        component: (
                            <>
                                <TransactionActions />
                                <Collection
                                    collection={fromColumns()}
                                    renderResource={(column: GridStateColDef) => (
                                        <Stack
                                            key={column.field}
                                            direction='row'
                                            spacing={3}
                                            py={1}
                                            px={2}
                                        >
                                            <Box
                                                sx={{
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                                {column.headerName}:
                                            </Box>
                                            <Box
                                                sx={{
                                                    userSelect: 'all'
                                                }}
                                            >
                                                {renderDetailRow(column)}
                                            </Box>
                                        </Stack>
                                    )}
                                />
                                <CurrentTransactionState />
                            </>
                        )
                    },
                    {
                        label: 'Child Transactions',
                        component: (
                            <ChildTransactions />
                        )
                    }
                ]
                    .slice(0, when(
                        !children.length,
                        1
                    ))}
            />
        </Paper>
    );
};

export default withTransaction(TransactionDetails);
